import Info from '../ui/Info';
import { connect } from 'react-redux';
import { acceptTerms, withdrawSubmit } from '../../actions';

const mapStateToProps = (state, props) => 
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content
  });

const mapDispatchToProps = dispatch =>
  ({
    onAcceptTerms(payload) {
      dispatch(
        acceptTerms(payload)
      );
    },
    onWithdrawSubmit(payload) {
      dispatch(
        withdrawSubmit(payload)
      );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Info);

export default Container;
